import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { AdminBaseUrl, AdminBaseUrl1, baseu11, baseurl } from "../../Basurl/Baseurl";
import { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import Swal from "sweetalert2";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { usePDF } from "react-to-pdf";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import TableSortLabel from "@mui/material/TableSortLabel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import InputAdornment from "@mui/material/InputAdornment";
import {
  MenuItem,
  Box,
  Pagination,
  Stack,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
} from "@mui/material";
import { GetAllTreatment } from "../../reducer/TreatmentSlice";
import {
  formatTime12Hour,
  getDateInputValue,
  getTimeInputValue,
  formatDisplayDate,
  formatDisplayDateTime,
  formatPaidAmount,
  formatTimeRange,
} from "../../utils/appointmentHelpers";
import { AppointmentForPatient } from "../../reducer/PatientTreatmentSlice";
import {
  getHospitalId,
  isHospitalUser,
} from "../../utils/authStorage";
import { canStaffDelete, canStaffEdit, canStaffExport } from "../../utils/staffActions";

const extractPatientDetails = (payload) => {
  if (!payload) return [];
  const details =
    payload.details ||
    payload.data?.details ||
    payload.patients ||
    payload.data?.patients ||
    (Array.isArray(payload.data) ? payload.data : null) ||
    (Array.isArray(payload) ? payload : []);
  return Array.isArray(details) ? details : [];
};

const getPatientOptionLabel = (p) => {
  if (!p) return "";
  const name = p.patient_name || "";
  const id = p.patientId || p.patientNumber || "";
  if (name && id) return `${name} (${id})`;
  return name || id || "";
};

const getAppointmentStatusValue = (status) => {
  if (status === "Follow-Up") return 2;
  if (status === "Complete" || status === "Completed") return 3;
  if (status === "Cancelled") return 4;
  if (status === "Reschedule") return 5;
  if (status === "Confirmed") return 6;
  return "Schedule";
};

const getAppStatusApiValue = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const s = String(value).trim().toLowerCase();
  if (s === "1" || s === "confirmed") return 1;
  if (s === "2" || s === "completed" || s === "complete") return 2;
  if (s === "3" || s === "cancelled" || s === "cancel") return 3;
  if (s === "4" || s === "follow-up" || s === "follow up" || s === "followup") return 4;
  if (s === "5" || s === "rescheduled" || s === "reschedule") return 5;
  const num = parseInt(value, 10);
  return isNaN(num) ? value : num;
};

const getAppAppointmentStatusCode = (status) => {
  if (status === null || status === undefined || status === "") return "";
  const s = String(status).trim().toLowerCase();
  if (s === "1" || s === "confirmed") return "1";
  if (s === "2" || s === "completed" || s === "complete") return "2";
  if (s === "3" || s === "cancelled" || s === "cancel") return "3";
  if (s === "4" || s === "follow-up" || s === "follow up" || s === "followup") return "4";
  if (s === "5" || s === "rescheduled" || s === "reschedule") return "5";
  return String(status);
};

const getAppAppointmentStatusLabel = (status) => {
  if (status === null || status === undefined || status === "") return "-";
  const s = String(status).trim().toLowerCase();
  if (s === "1" || s === "confirmed") return "Confirmed";
  if (s === "2" || s === "completed" || s === "complete") return "Completed";
  if (s === "3" || s === "cancelled" || s === "cancel") return "Cancelled";
  if (s === "4" || s === "follow-up" || s === "follow up" || s === "followup") return "Follow-Up";
  if (s === "5" || s === "rescheduled" || s === "reschedule") return "Rescheduled";
  return String(status);
};

const getAppAppointmentStatusValue = (status) => getAppAppointmentStatusCode(status);

function TabPanel({ children, value, index }) {
  return value === index && <Box sx={{ p: 2 }}>{children}</Box>;
}
export default function Appointments() {
  const dispatch = useDispatch();
  const role = localStorage.getItem("Role");
  const hospitalUser = isHospitalUser();
  const allowEdit = canStaffEdit();
  const allowDelete = canStaffDelete();
  const allowExport = canStaffExport();
  const [tabValue, setTabValue] = useState(0);
  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [editImages, setEditImages] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [searchApiData, setSearchApiData] = useState([]);
  const [page, setPage] = useState(0);
  const [orderByCRM, setOrderByCRM] = useState("");
  const [orderDirectionCRM, setOrderDirectionCRM] = useState("asc");
  const [hospitalList, setHospitalList] = useState([]);
  const [orderByAPP, setOrderByAPP] = useState("");
  const [orderDirectionAPP, setOrderDirectionAPP] = useState("asc");
  const [pageAPP, setPageAPP] = useState(0);
  const [rowsPerPageAPP] = useState(10);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dataApp, setDataApp] = useState([]);
  const [searchDataApp, setSearchDataApp] = useState([]);
  const [searchDataEnq, setSearchDataEnq] = useState([]);
  const fullWidth = true;
  const [openViewEnq, setOpenViewEnq] = useState(false);
  const [selectedEnq, setSelectedEnq] = useState(null);
  const maxWidth = "md"; // xs | sm | md | lg | xl
  const [open, setOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [pdfRowLimit, setPdfRowLimit] = useState(null);
  const [statuddropdown, setStatuddropdown] = useState("offline");
  const [filterValue, setFilterValue] = useState("");
  const { toPDF, targetRef } = usePDF({ filename: "page.pdf" });
  const { Treatment, error } = useSelector((state) => state.Treatment);
  const [appointmentPatientOptions, setAppointmentPatientOptions] = useState([]);
  const [loadingAppointmentPatients, setLoadingAppointmentPatients] = useState(false);
  const [enquiryAppointments, setEnquiryAppointments] = useState([]);
  const [pageENQ, setPageENQ] = useState(0);
  const [orderByENQ, setOrderByENQ] = useState("");
  const [orderDirectionENQ, setOrderDirectionENQ] = useState("asc");
  const [rowsPerPageENQ] = useState(10);
  const [openReschedule, setOpenReschedule] = useState(false);
  const [rescheduleSubmitting, setRescheduleSubmitting] = useState(false);
  const [rescheduleData, setRescheduleData] = useState({
    type: "",
    appointmentId: "",
    patientName: "",
    currentAppointment: "",
    appointment_Date: "",
    appointment_Time: "",
  });
  const [openConfirm, setOpenConfirm] = useState(false);
  const [confirmSubmitting, setConfirmSubmitting] = useState(false);
  const [confirmData, setConfirmData] = useState({
    appointmentId: "",
    patientName: "",
    currentAppointment: "",
    appointment_Date: "",
    appointment_Time: "",
  });
  const [openCancel, setOpenCancel] = useState(false);
  const [cancelSubmitting, setCancelSubmitting] = useState(false);
  const [cancelReasons, setCancelReasons] = useState([]);
  const [cancelData, setCancelData] = useState({
    appointmentId: "",
    patientName: "",
    currentAppointment: "",
    cancel_reason_id: "",
    cancel_note: "",
  });
  const [openCreate, setOpenCreate] = useState(false);
  const [createSubmitting, setCreateSubmitting] = useState(false);
  const [patientTreatments, setPatientTreatments] = useState([]);
  const [createData, setCreateData] = useState({
    patient: null,
    treatment_id: "",
    hospital_id: "",
    hospital_Name: "",
    hospital_email: "",
    appointment_Date: "",
    appointment_Time: "",
    appointment_Time_From: "",
    appointment_Time_To: "",
    note: "",
    mode: "offline",
  });

  const fetchCancelReasons = async () => {
    try {
      const formData = new FormData();
      formData.append("type", "doctor");
      const response = await axios.post(
        `${AdminBaseUrl1}appointment_cancel_reasons`,
        formData
      );
      const reasons =
        response.data?.data ||
        response.data?.reasons ||
        [];
      setCancelReasons(Array.isArray(reasons) ? reasons : []);
    } catch (error) {
      console.error("Error fetching cancel reasons:", error);
      toast.error("Failed to load cancellation reasons");
    }
  };

  const openCancelDialog = (appointmentId, item) => {
    fetchCancelReasons();
    setCancelData({
      appointmentId,
      patientName: item?.name || item?.patientName || "-",
      currentAppointment:
        item?.apt_on ||
        formatDisplayDateTime(
          item?.appointment_Date,
          item?.appointment_Time,
        ),
      cancel_reason_id: "",
      cancel_note: "",
    });
    setOpenCancel(true);
  };

  const openRescheduleDialog = (type, appointmentId, item) => {
    let aptDate = item?.appointment_Date || "";
    let aptTime = item?.appointment_Time || "";

    if (!aptDate && item?.apt_on) {
      const parts = String(item.apt_on).trim().split(" ");
      if (parts[0] && parts[0].includes("/")) {
        const [d, m, y] = parts[0].split("/");
        aptDate = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
      }
      if (parts.length >= 2) {
        aptTime = parts.slice(1).join(" ");
      }
    }

    setRescheduleData({
      type,
      appointmentId,
      patientName: item?.patientName || item?.name || "-",
      currentAppointment:
        item?.apt_on ||
        formatDisplayDateTime(
          item?.appointment_Date,
          item?.appointment_Time,
        ),
      appointment_Date: getDateInputValue(aptDate),
      appointment_Time: getTimeInputValue(aptDate, aptTime),
    });
    setOpenReschedule(true);
  };

  const openConfirmDialog = (appointmentId, item) => {
    let aptDate = item?.appointment_Date || "";
    let aptTime = item?.appointment_Time || "";

    if (!aptDate && item?.apt_on) {
      const parts = String(item.apt_on).trim().split(" ");
      if (parts[0] && parts[0].includes("/")) {
        const [d, m, y] = parts[0].split("/");
        aptDate = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
      }
      if (parts.length >= 2) {
        aptTime = parts.slice(1).join(" ");
      }
    }

    setConfirmData({
      appointmentId,
      patientName: item?.patientName || item?.name || "-",
      currentAppointment:
        item?.apt_on ||
        formatDisplayDateTime(
          item?.appointment_Date,
          item?.appointment_Time,
        ),
      appointment_Date: getDateInputValue(aptDate),
      appointment_Time: getTimeInputValue(aptDate, aptTime),
    });
    setOpenConfirm(true);
  };

  const resetCreateForm = () => {
    setCreateData({
      patient: null,
      treatment_id: "",
      hospital_id: hospitalUser ? getHospitalId() : "",
      hospital_Name: "",
      hospital_email: "",
      appointment_Date: "",
      appointment_Time: "",
      appointment_Time_From: "",
      appointment_Time_To: "",
      note: "",
      mode: "offline",
    });
    setPatientTreatments([]);
  };

  const fetchAllPatientsForAppointment = async () => {
    setLoadingAppointmentPatients(true);
    try {
      const limit = 500;
      let page = 1;
      let totalPages = 1;
      const allPatients = [];

      while (page <= totalPages) {
        const response = await axios.get(
          `${baseurl}all_patients?page=${page}&limit=${limit}&search=`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        const payload = response.data;
        allPatients.push(...extractPatientDetails(payload));
        totalPages = payload?.pagination?.totalPages || 1;
        page += 1;
      }

      setAppointmentPatientOptions(allPatients);
    } catch (err) {
      console.error("Error fetching patients for appointment:", err);
      toast.error("Failed to load patients");
      setAppointmentPatientOptions([]);
    } finally {
      setLoadingAppointmentPatients(false);
    }
  };

  const handleOpenCreate = () => {
    resetCreateForm();
    fetchAllPatientsForAppointment();
    if (!hospitalList?.length) {
      getHospitalList();
    }
    setOpenCreate(true);
  };

  const handleCloseCreate = () => {
    setOpenCreate(false);
    resetCreateForm();
  };

  const fetchPatientTreatments = async (patientId) => {
    if (!patientId) {
      setPatientTreatments([]);
      return;
    }
    try {
      const response = await axios.get(`${baseurl}get_patient/${patientId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      const treatments =
        response?.data?.detail?.treatments ||
        response?.data?.detail?.treatment ||
        response?.data?.treatments ||
        [];
      setPatientTreatments(Array.isArray(treatments) ? treatments : []);
    } catch (err) {
      console.error("Error fetching patient treatments:", err);
      setPatientTreatments([]);
      toast.error("Failed to load patient treatments");
    }
  };

  const handleCreateSubmit = async () => {
    const {
      patient,
      treatment_id,
      hospital_id,
      hospital_Name,
      hospital_email,
      appointment_Date,
      appointment_Time,
      appointment_Time_From,
      appointment_Time_To,
      note,
      mode,
    } = createData;

    const patientId = patient?.patientId || "";
    const resolvedHospitalId = hospitalUser
      ? getHospitalId() || hospital_id
      : hospital_id;

    if (!patientId) {
      return Swal.fire("Error", "Please select a patient", "error");
    }
    if (!resolvedHospitalId && !hospital_Name) {
      return Swal.fire("Error", "Please select a hospital", "error");
    }
    if (!appointment_Date) {
      return Swal.fire("Error", "Please select appointment date", "error");
    }

    let finalTime = "";
    if (appointment_Time_From && appointment_Time_To) {
      finalTime = `${formatTime12Hour(appointment_Time_From)} to ${formatTime12Hour(appointment_Time_To)}`;
    } else if (appointment_Time_From) {
      finalTime = formatTime12Hour(appointment_Time_From);
    } else if (appointment_Time) {
      finalTime = formatTime12Hour(appointment_Time);
    }

    if (!finalTime) {
      return Swal.fire("Error", "Please select appointment time range", "error");
    }
    if (!note?.trim()) {
      return Swal.fire("Error", "Please enter a note", "error");
    }
    if (createSubmitting) return;

    setCreateSubmitting(true);
    try {
      await dispatch(
        AppointmentForPatient({
          patientId,
          hospital_id: resolvedHospitalId,
          hospitalId: resolvedHospitalId,
          hospital_Name: hospital_Name || undefined,
          hospital_email: hospital_email || undefined,
          treatment_id,
          note: note.trim(),
          mode,
          appointment_Date,
          appointment_Time: finalTime,
        }),
      ).unwrap();

      Swal.fire("Success!", "Appointment created successfully!", "success");
      handleCloseCreate();
      await getAppointments();
    } catch (err) {
      Swal.fire(
        "Error!",
        err?.message ||
          (Array.isArray(err) ? err.join(", ") : null) ||
          "Failed to create appointment",
        "error",
      );
    } finally {
      setCreateSubmitting(false);
    }
  };

  const handleRescheduleSubmit = async () => {
    const { type, appointmentId, appointment_Date, appointment_Time } =
      rescheduleData;

    if (!appointment_Date) {
      return Swal.fire("Error", "Please select appointment date", "error");
    }
    if (!appointment_Time) {
      return Swal.fire("Error", "Please select appointment time", "error");
    }
    if (rescheduleSubmitting) return;

    setRescheduleSubmitting(true);
    try {
      const formattedTime = formatTime12Hour(appointment_Time);

      if (type === "app") {
        try {
          const response = await axios.post(
            `${AdminBaseUrl}update_user_request_status`,
            {
              id: appointmentId,
              model: "Patientcontact",
              status: 5,
              apt_date: appointment_Date,
              apt_time: formattedTime,
            },
          );

          if (
            response.data?.success === false ||
            response.data?.success === "false" ||
            response.data?.status === false
          ) {
            throw new Error(
              response.data?.message || "Failed to reschedule appointment",
            );
          }

          setDataApp((prev) =>
            prev.map((appItem) =>
              appItem.id === appointmentId || appItem._id === appointmentId
                ? {
                    ...appItem,
                    status: "5",
                    apt_on: `${formatDisplayDate(appointment_Date)} ${formattedTime}`,
                  }
                : appItem,
            ),
          );
          setSearchDataApp((prev) =>
            prev.map((appItem) =>
              appItem.id === appointmentId || appItem._id === appointmentId
                ? {
                    ...appItem,
                    status: "5",
                    apt_on: `${formatDisplayDate(appointment_Date)} ${formattedTime}`,
                  }
                : appItem,
            ),
          );

          Swal.fire(
            "Success!",
            response.data?.message || "Appointment rescheduled successfully!",
            "success",
          );
          setOpenReschedule(false);
          getAppFromApp();
        } catch (apiErr) {
          console.error("Reschedule app appointment API error:", apiErr);
          const errMsg =
            apiErr.response?.data?.message ||
            apiErr.message ||
            "Failed to reschedule appointment";
          Swal.fire("Error!", errMsg, "error");
          toast.error(errMsg);
          getAppFromApp();
        }
        return;
      }

      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Authorization token is missing");
      }

      const payload =
        type === "treatment"
          ? {
              status: 5,
              appointment_Date,
              appointment_Time: formattedTime,
            }
          : {
              status: "Reschedule",
              appointment_Date,
              appointment_Time: formattedTime,
            };

      const endpoint =
        type === "treatment"
          ? `${baseurl}update_appointment_status/${appointmentId}`
          : `${baseurl}update_enqAppointment_status/${appointmentId}`;

      const response = await axios.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200 || response.status === 201) {
        Swal.fire("Success!", "Appointment rescheduled successfully!", "success");
        setOpenReschedule(false);
        if (type === "treatment") {
          await getAppointments();
        } else {
          getEnquiryAppointments();
        }
      } else {
        throw new Error("Failed to reschedule appointment. Please try again!");
      }
    } catch (err) {
      console.error("Reschedule Error:", err);
      if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else if (err.message) {
        toast.error(err.message);
      } else {
        toast.error("Something went wrong. Please try again!");
      }
    } finally {
      setRescheduleSubmitting(false);
    }
  };

  const handleConfirmSubmit = async () => {
    const { appointmentId, appointment_Date, appointment_Time } = confirmData;

    if (!appointment_Date) {
      return Swal.fire("Error", "Please select appointment date", "error");
    }
    if (!appointment_Time) {
      return Swal.fire("Error", "Please select exact appointment time", "error");
    }
    if (confirmSubmitting) return;

    setConfirmSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Authorization token is missing");
      }

      const formattedTime = formatTime12Hour(appointment_Time);
      const payload = {
        status: 6,
        appointment_Date,
        appointment_Time: formattedTime,
      };

      const response = await axios.post(
        `${baseurl}update_appointment_status/${appointmentId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire("Success!", "Appointment confirmed successfully!", "success");
        setOpenConfirm(false);
        await getAppointments();
      } else {
        throw new Error("Failed to confirm appointment. Please try again!");
      }
    } catch (err) {
      console.error("Confirm Appointment Error:", err);
      if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else if (err.message) {
        toast.error(err.message);
      } else {
        toast.error("Something went wrong. Please try again!");
      }
    } finally {
      setConfirmSubmitting(false);
    }
  };

  const handleCancelSubmit = async () => {
    const {
      appointmentId,
      cancel_reason_id,
      cancel_note,
    } = cancelData;

    if (!cancel_reason_id) {
      return Swal.fire("Error", "Please select a cancellation reason", "error");
    }
    if (cancelSubmitting) return;

    setCancelSubmitting(true);
    try {
      const response = await axios.post(
        `${AdminBaseUrl}update_user_request_status`,
        {
          id: appointmentId,
          model: "Patientcontact",
          status: 3,
          cancel_reason_id: cancel_reason_id,
          cancel_note: cancel_note ? cancel_note.trim() : "",
        }
      );

      if (
        response.data?.success === false ||
        response.data?.success === "false" ||
        response.data?.status === false
      ) {
        throw new Error(
          response.data?.message || "Failed to cancel appointment"
        );
      }

      setDataApp((prev) =>
        prev.map((appItem) =>
          appItem.id === appointmentId || appItem._id === appointmentId
            ? { ...appItem, status: "3" }
            : appItem
        )
      );
      setSearchDataApp((prev) =>
        prev.map((appItem) =>
          appItem.id === appointmentId || appItem._id === appointmentId
            ? { ...appItem, status: "3" }
            : appItem
        )
      );

      Swal.fire(
        "Success!",
        response.data?.message || "Appointment cancelled successfully!",
        "success"
      );
      setOpenCancel(false);
      getAppFromApp();
    } catch (err) {
      console.error("Cancel appointment error:", err);
      const errMsg =
        err.response?.data?.message ||
        err.message ||
        "Failed to cancel appointment";
      Swal.fire("Error!", errMsg, "error");
      toast.error(errMsg);
      getAppFromApp();
    } finally {
      setCancelSubmitting(false);
    }
  };

  const handleAppStatusChange = async (e, appointmentId, item) => {
    const rawValue = e.target.value;
    const apiStatus = getAppStatusApiValue(rawValue);

    if (
      rawValue === "5" ||
      rawValue === 5 ||
      apiStatus === 5 ||
      apiStatus === "Reschedule" ||
      apiStatus === "Rescheduled"
    ) {
      openRescheduleDialog("app", appointmentId, item);
      return;
    }

    if (
      rawValue === "3" ||
      rawValue === 3 ||
      apiStatus === 3 ||
      apiStatus === "Cancelled" ||
      apiStatus === "Cancel" ||
      apiStatus === "cancel"
    ) {
      openCancelDialog(appointmentId, item);
      return;
    }

    try {
      const response = await axios.post(
        `${AdminBaseUrl}update_user_request_status`,
        {
          id: appointmentId,
          model: "Patientcontact",
          status: apiStatus,
        },
      );

      if (
        response.data?.success === false ||
        response.data?.success === "false" ||
        response.data?.status === false
      ) {
        throw new Error(
          response.data?.message || "Failed to update status",
        );
      }

      setDataApp((prev) =>
        prev.map((appItem) =>
          appItem.id === appointmentId || appItem._id === appointmentId
            ? { ...appItem, status: rawValue }
            : appItem,
        ),
      );
      setSearchDataApp((prev) =>
        prev.map((appItem) =>
          appItem.id === appointmentId || appItem._id === appointmentId
            ? { ...appItem, status: rawValue }
            : appItem,
        ),
      );

      Swal.fire(
        "Success!",
        response.data?.message || "Status updated successfully!",
        "success",
      );
      getAppFromApp();
    } catch (err) {
      console.error("App status update error:", err);
      const errMsg =
        err.response?.data?.message ||
        err.message ||
        "Failed to update status";
      Swal.fire("Error!", errMsg, "error");
      toast.error(errMsg);
      getAppFromApp();
    }
  };

  const handleChange = async (e, i, item) => {
    const statusValue = parseInt(e.target.value, 10);
    if (statusValue === 5) {
      openRescheduleDialog("treatment", i, item);
      return;
    }
    if (statusValue === 6) {
      openConfirmDialog(i, item);
      return;
    }

    try {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("Authorization token is missing");
      }
      const response = await axios.post(
        `${baseurl}update_appointment_status/${i}`,
        { status: statusValue },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200 || response.status === 201) {
        Swal.fire("Success!", "Status updated successfully!", "success");
        try {
          await getAppointments(); // make sure it's awaited if it’s async
        } catch (refreshError) {
          console.error("Error refreshing appointments:", refreshError);
          toast.error("Failed to refresh appointments!");
        }
        return response.data;
      } else {
        throw new Error("Failed to update status. Please try again!");
      }
    } catch (err) {
      console.error("Full Error:", err);
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(err.response.data.message);
      } else if (err.message) {
        toast.error(err.message);
      } else {
        toast.error("Something went wrong. Please try again!");
      }
    }
  };

  const getEnquiryAppointments = async () => {
    try {
      const response = await axios.get(`${baseurl}get_enquiry_appointments`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.status === 200) {
        const enqData = response.data.data || [];
        setEnquiryAppointments(enqData);
        setSearchDataEnq(enqData);
      }
    } catch (error) {
      console.log("Error fetching enquiry appointments:", error);
    }
  };
  const getAppointments = () => {
    axios
      .get(`${baseurl}all_appointment`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.status === 200) {
          setAppointments(response.data.data);
          setSearchApiData(response.data.data);
        } else {
          console.error("Failed to fetch job titles:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching job titles:", error);
      });
  };
  useEffect(() => {
    getAppointments();
    getEnquiryAppointments();
    getAppFromApp();
    dispatch(GetAllTreatment());
    getHospitalList(); // 👈 ye missing tha
  }, []);
  const handleFilter = (event) => {
    const value = event.target.value.toLowerCase();
    setFilterValue(event.target.value);
    setPage(0); // ⭐ IMPORTANT
    setPageAPP(0);
    setPageENQ(0);

    if (value === "") {
      setAppointments(searchApiData);
      setDataApp(searchDataApp);
      setEnquiryAppointments(searchDataEnq);
      return;
    }

    const filterResult = searchApiData.filter((item) => {
      const enquiryId = item.patientId?.toLowerCase() || "";
      const country = item.patientName?.toLowerCase() || "";
      const Hospital_name = item.Hospital_name?.toLowerCase() || "";
      const appointement_status = item.appointement_status?.toLowerCase() || "";
      const appointmentId = item.appointmentId?.toLowerCase() || "";
      const disease_name = item.disease_name?.toLowerCase() || "";

      return (
        enquiryId.includes(value) ||
        Hospital_name.includes(value) ||
        appointement_status.includes(value) ||
        disease_name.includes(value) ||
        appointmentId.includes(value) ||
        country.includes(value)
      );
    });
    setAppointments(filterResult);

    const filterResultAPP = searchDataApp.filter((item) => {
      const name = item.name?.toLowerCase() || "";
      const email = item.email?.toLowerCase() || "";
      const city = item.city?.toLowerCase() || "";
      const health_issue = item.health_issue?.toLowerCase() || "";
      const doctor = item.doctor?.toLowerCase() || "";
      const treatment = item.treatment?.toLowerCase() || "";
      const apt_on = item.apt_on?.toLowerCase() || "";
      const statusRaw = String(item.status || item.appointement_status || "").toLowerCase();
      const statusLabel = getAppAppointmentStatusLabel(item.status || item.appointement_status).toLowerCase();

      return (
        name.includes(value) ||
        email.includes(value) ||
        city.includes(value) ||
        health_issue.includes(value) ||
        doctor.includes(value) ||
        treatment.includes(value) ||
        apt_on.includes(value) ||
        statusRaw.includes(value) ||
        statusLabel.includes(value)
      );
    });
    setDataApp(filterResultAPP);

    const filterResultENQ = searchDataEnq.filter((item) => {
      const patientName = item.patientName?.toLowerCase() || "";
      const health_issue = item.health_issue?.toLowerCase() || "";
      const treatment_name = item.treatment_name?.toLowerCase() || "";
      const status = item.status?.toLowerCase() || "";

      return (
        patientName.includes(value) ||
        health_issue.includes(value) ||
        treatment_name.includes(value) ||
        status.includes(value)
      );
    });
    setEnquiryAppointments(filterResultENQ);
  };
  const getHospitalList = async () => {
    try {
      const res = await axios.post(`${AdminBaseUrl}hospital_list`);
      if (res.status === 200) {
        setHospitalList(res.data.data);
      }
    } catch (err) {
      console.log("Hospital list error:", err);
    }
  };
  const handleClearFilter = () => {
    setFilterValue("");
    setAppointments(searchApiData);
    setDataApp(searchDataApp);
    setEnquiryAppointments(searchDataEnq);
    setPage(0); // ⭐ IMPORTANT
    setPageAPP(0);
    setPageENQ(0);
  };
  const handleTabChange = (_, newVal) => {
    setTabValue(newVal);

    if (newVal === 0) setPage(0);
    else if (newVal === 1) setPageAPP(0);
    else if (newVal === 2) setPageENQ(0); // ✅ NEW
  };
  const handleDelete = async (item) => {
    try {
      const confirm = await Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this appointment!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6e7881",
        confirmButtonText: "Yes, delete it!",
      });
      if (!confirm.isConfirmed) return;
      const response = await axios.post(
        `${baseurl}delete_enqAppointment/${item._id}`,
      );
      if (response.status === 200 || response.status === 201) {
        Swal.fire("Deleted!", "Appointment deleted successfully.", "success");

        // 🔁 refresh list after delete
        getEnquiryAppointments();
      } else {
        Swal.fire("Error!", "Failed to delete appointment.", "error");
      }
    } catch (error) {
      console.log(error);
      Swal.fire("Error!", "Something went wrong.", "error");
    }
  };
  const handleEdit = (item) => {
    console.log(item);
    setEditData({
      ...item,
      hospital_id: Number(item.hospital_id), // ✅ ensure number
    });
    setOpenEdit(true);
  };

  const handleSampleFile = () => {
    fetch(`${baseurl}export_appointments`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = ""; // Let browser use filename from API
        a.click();
        window.URL.revokeObjectURL(url);
      });
  };

  const handleViewEnq = (item) => {
    setSelectedEnq(item);
    setOpenViewEnq(true);
  };

  const handleCloseViewEnq = () => {
    setOpenViewEnq(false);
  };
  const downloadPdf = async () => {
    const maxRows = appointments.length || 1;
    Swal.fire({
      title: "Enter number of rows for PDF",
      input: "number",
      inputLabel: `Choose between 1 and ${maxRows}`,
      inputAttributes: {
        min: "1",
        max: maxRows.toString(),
        step: "1",
      },
      inputValue: rowsPerPage,
      showCancelButton: true,
      confirmButtonText: "Generate PDF",
    }).then((result) => {
      if (result.isConfirmed) {
        const userInput = parseInt(result.value, 10);
        if (isNaN(userInput) || userInput < 1 || userInput > maxRows) {
          Swal.fire(
            "Invalid entry",
            `Please enter a number between 1 and ${maxRows}`,
            "error",
          );
          return;
        }
        setPdfRowLimit(userInput);
        setTimeout(() => {
          toPDF();
          setPdfRowLimit(null); // reset to normal view
        }, 300);
      }
    });
  };
  const getAppFromApp = async () => {
    try {
      const response = await axios.post(`${AdminBaseUrl}app_appointments`);
      console.log(response.data.data);
      const appData = response.data.data || [];
      setDataApp(appData);
      setSearchDataApp(appData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    setPage(0);
  }, [appointments]);

  useEffect(() => {
    setPageAPP(0);
  }, [dataApp]);
  const handleView = (record) => {
    setSelectedRecord(record);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const InfoItem = ({ label, value }) => (
    <div className="">
      <h6>{label}</h6>
      <p>{value || "-"}</p>
    </div>
  );
  const sortData = (data, field, direction) => {
    return [...data].sort((a, b) => {
      let valA = a[field];
      let valB = b[field];
      if (field === "appointment_Date" || field === "apt_on") {
        return direction === "asc"
          ? new Date(valA) - new Date(valB)
          : new Date(valB) - new Date(valA);
      }
      if (field === "paid_amount") {
        return direction === "asc"
          ? Number(valA) - Number(valB)
          : Number(valB) - Number(valA);
      }
      if (typeof valA === "string") {
        return direction === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }
      return 0;
    });
  };
  const handleUpdate = async () => {
    try {
      // ✅ Validation
      if (!editData.appointment_Date) {
        return Swal.fire("Error", "Appointment Date is required", "error");
      }

      if (!editData.appointment_Time) {
        return Swal.fire("Error", "Appointment Time is required", "error");
      }

      if (!editData.discussionNotes || editData.discussionNotes.trim() === "") {
        return Swal.fire("Error", "Notes are required", "error");
      }

      // ✅ API Call
      const formData = new FormData();
      formData.append("appointmentId", editData._id);
      formData.append("health_issue", editData.health_issue);
      formData.append("discussionNotes", editData.discussionNotes);
      formData.append("appointment_Date", editData.appointment_Date);
      formData.append("appointment_Time", formatTime12Hour(editData.appointment_Time));
      formData.append("hospital_id", editData.hospital_id);
      formData.append("hospitalName", editData.hospitalName);
      formData.append("treatment_id", editData.treatment_id);
      formData.append("treatment_name", editData.treatment_name);

      editImages.forEach((file) => {
        formData.append("reports", file);
      });

      const res = await axios.post(
        `${baseurl}update_enquiry_appointment`,
        formData,
      );

      if (res.data.success) {
        Swal.fire("Success", "Updated Successfully", "success");
        setOpenEdit(false);
        getEnquiryAppointments();
      }
    } catch (err) {
      console.log(err);
      Swal.fire("Error", "Update Failed", "error");
    }
  };
  const handleSortCRM = (field) => {
    const isAsc = orderByCRM === field && orderDirectionCRM === "asc";
    const direction = isAsc ? "desc" : "asc";

    setOrderByCRM(field);
    setOrderDirectionCRM(direction);

    const sorted = sortData(appointments, field, direction);
    setAppointments(sorted);
  };
  const handleSortAPP = (field) => {
    const isAsc = orderByAPP === field && orderDirectionAPP === "asc";
    const direction = isAsc ? "desc" : "asc";
    setOrderByAPP(field);
    setOrderDirectionAPP(direction);
    const sorted = sortData(dataApp, field, direction);
    setDataApp(sorted);
  };
  const handleSortENQ = (field) => {
    const isAsc = orderByENQ === field && orderDirectionENQ === "asc";
    const direction = isAsc ? "desc" : "asc";

    setOrderByENQ(field);
    setOrderDirectionENQ(direction);

    const sorted = sortData(enquiryAppointments, field, direction);
    setEnquiryAppointments(sorted);
  };

  const handleEnqStatusChange = async (e, appointmentId, item) => {
    if (e.target.value === "Reschedule") {
      openRescheduleDialog("enquiry", appointmentId, item);
      return;
    }

    try {
      console.log(e.target.value);
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${baseurl}update_enqAppointment_status/${appointmentId}`,
        { status: e.target.value },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        Swal.fire("Success!", "Status updated successfully!", "success");

        // refresh data
        getEnquiryAppointments();
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to update status");
    }
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row gx-3">
            <div className="col-md-12">
              <div className="topmainhd">
                <h6>Manage Appointments</h6>
              </div>
            </div>
            <div className="col-md-12">
              <div className="country-top">
                <Box>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    TabIndicatorProps={{
                      style: {
                        display: "none",
                      },
                    }}
                    sx={{
                      minHeight: "40px",
                      "& .MuiTabs-flexContainer": {
                        gap: "10px",
                      },
                    }}
                  >
                    <Tab
                      label="Appointments By CRM"
                      sx={{
                        textTransform: "none",
                        fontSize: "12px",
                        fontWeight: 500,
                        fontFamily: "Rubik",
                        padding: "8px 18px",
                        lineHeight: "22px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        color: "#666",
                        transition: "0.3s",
                        minHeight: "0px",
                        "&.Mui-selected": {
                          background: "#22c7b8",
                          color: "#fff",
                        },
                      }}
                    />

                    <Tab
                      label="Appointments By APP"
                      sx={{
                        textTransform: "none",
                        fontSize: "12px",
                        fontWeight: 500,
                        fontFamily: "Rubik",
                        padding: "8px 18px",
                        lineHeight: "22px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        color: "#666",
                        transition: "0.3s",
                        minHeight: "0px",
                        "&.Mui-selected": {
                          background: "#22c7b8",
                          color: "#fff",
                        },
                      }}
                    />

                    <Tab
                      label="Enquiry Appointments"
                      sx={{
                        textTransform: "none",
                        fontSize: "12px",
                        fontWeight: 500,
                        fontFamily: "Rubik",
                        padding: "8px 18px",
                        lineHeight: "22px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        color: "#666",
                        transition: "0.3s",
                        minHeight: "0px",
                        "&.Mui-selected": {
                          background: "#22c7b8",
                          color: "#fff",
                        },
                      }}
                    />
                  </Tabs>
                </Box>
                <div className="search-btn-main">
                  <div className="">
                    <TextField
                      className="field-count"
                      label="Search"
                      id="outlined-size-small"
                      size="small"
                      value={filterValue}
                      onChange={(e) => handleFilter(e)}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" className="input-set">
                            {filterValue && (
                              <IconButton
                                onClick={handleClearFilter}
                                edge="end"
                              >
                                <ClearIcon />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <button onClick={handleOpenCreate} className="add-button">
                    <span>
                      <i className="fa fa-plus me-2"></i>
                    </span>
                    Create Appointment
                  </button>
                  {allowExport && (
                  <button onClick={handleSampleFile} className="add-button">
                    <span>
                      <i className="fa fa-file me-2"></i>
                    </span>
                    Export File
                  </button>
                  )}
                  {role === "Admin" ? (
                    <button onClick={downloadPdf} className="add-button ">
                      <span>
                        <i className="fa fa-file-pdf-o me-2"></i>
                      </span>
                      Pdf
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <TabPanel value={tabValue} index={0}>
                <div className="main_content">
                  <div className="table-responsive">
                    <TableContainer
                      component={Paper}
                      style={{ overflowX: "auto" }}
                      ref={targetRef}
                    >
                      <Table
                        stickyHeader
                        aria-label="sticky table"
                        className="table-no-card"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr.No.</TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={orderByCRM === "patientId"}
                                direction={
                                  orderByCRM === "patientId"
                                    ? orderDirectionCRM
                                    : "asc"
                                }
                                onClick={() => handleSortCRM("patientId")}
                              >
                                Patient ID
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={orderByCRM === "patientName"}
                                direction={
                                  orderByCRM === "patientName"
                                    ? orderDirectionCRM
                                    : "asc"
                                }
                                onClick={() => handleSortCRM("patientName")}
                              >
                                Patient Name
                              </TableSortLabel>
                            </TableCell>
                            {/* <TableCell>Disease Name</TableCell> */}
                            <TableCell>
                              <TableSortLabel
                                active={orderByCRM === "disease_name"}
                                direction={
                                  orderByCRM === "disease_name"
                                    ? orderDirectionCRM
                                    : "asc"
                                }
                                onClick={() => handleSortCRM("disease_name")}
                              >
                                Disease Name
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={orderByCRM === "patientName"}
                                direction={
                                  orderByCRM === "patientName"
                                    ? orderDirectionCRM
                                    : "asc"
                                }
                                onClick={() => handleSortCRM("patientName")}
                              >
                                Appointment Id
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={orderByCRM === "appointment_Date"}
                                direction={
                                  orderByCRM === "appointment_Date"
                                    ? orderDirectionCRM
                                    : "asc"
                                }
                                onClick={() =>
                                  handleSortCRM("appointment_Date")
                                }
                              >
                                Appointment Date & Time
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={orderByCRM === "Hospital_name"}
                                direction={
                                  orderByCRM === "Hospital_name"
                                    ? orderDirectionCRM
                                    : "asc"
                                }
                                onClick={() => handleSortCRM("Hospital_name")}
                              >
                                Hospital Name
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={orderByCRM === "appointement_status"}
                                direction={
                                  orderByCRM === "appointement_status"
                                    ? orderDirectionCRM
                                    : "asc"
                                }
                                onClick={() =>
                                  handleSortCRM("appointement_status")
                                }
                              >
                                Status
                              </TableSortLabel>
                            </TableCell>
                            {/* <TableCell>Status</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {appointments.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={8} align="center">
                                No data found
                              </TableCell>
                            </TableRow>
                          ) : (
                            (pdfRowLimit
                              ? appointments.slice(0, pdfRowLimit)
                              : appointments.slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage,
                                )
                            ).map((info, i) => (
                              <TableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={info.code}
                              >
                                <TableCell>
                                  {pdfRowLimit
                                    ? i + 1
                                    : page * rowsPerPage + i + 1}
                                </TableCell>
                                <TableCell>{info.patientId}</TableCell>
                                <TableCell title={info?.patientName}>
                                  {info?.patientName?.slice(0, 12)}
                                  {info?.patientName?.length > 12 ? "..." : ""}
                                </TableCell>
                                {/* <TableCell>{info.patientName}</TableCell> */}
                                <TableCell title={info?.disease_name}>
                                  {info?.disease_name?.slice(0, 12)}
                                  {info?.disease_name?.length > 12 ? "..." : ""}
                                </TableCell>
                                <TableCell>{info.appointmentId}</TableCell>
                                <TableCell>
                                  {formatDisplayDateTime(
                                    info.appointment_Date,
                                    info.appointment_Time,
                                  )}
                                </TableCell>
                                <TableCell title={info?.Hospital_name}>
                                  {info?.Hospital_name?.slice(0, 12)}
                                  {info?.Hospital_name?.length > 12
                                    ? "..."
                                    : ""}
                                </TableCell>
                                <TableCell>
                                  <FormControl
                                    sx={{ m: 1, minWidth: 120 }}
                                    size="small"
                                    className="cont-main"
                                  >
                                    <Select
                                      value={getAppointmentStatusValue(
                                        info.appointement_status,
                                      )}
                                      onChange={(e) =>
                                        handleChange(e, info.appointmentId, info)
                                      }
                                      displayEmpty
                                      inputProps={{
                                        "aria-label": "Without label",
                                      }}
                                      className="status-direct"
                                    >
                                      <MenuItem value="Schedule" disabled>
                                        Schedule
                                      </MenuItem>
                                      <MenuItem value="6">Confirmed</MenuItem>
                                      <MenuItem value="2">Follow-Up</MenuItem>
                                      <MenuItem value="3"> Completed</MenuItem>
                                      <MenuItem value="4">Cancelled</MenuItem>
                                      <MenuItem value="5">Reschedule</MenuItem>
                                    </Select>
                                  </FormControl>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                      {!pdfRowLimit && (
                        <Stack spacing={2} alignItems="end" marginTop={2}>
                          <Pagination
                            count={Math.ceil(appointments.length / rowsPerPage)}
                            page={page + 1}
                            onChange={(event, value) => setPage(value - 1)}
                            shape="rounded"
                            className="page-item"
                          />
                        </Stack>
                      )}
                    </TableContainer>
                  </div>
                </div>
                <div
                  id="delete_appointment"
                  className="modal fade delete-modal"
                  role="dialog"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-body text-center">
                        <img
                          src="assets/img/sent.png"
                          alt=""
                          width="50"
                          height="46"
                        />
                        <h3>Are you sure want to delete this Appointment?</h3>
                        <div className="m-t-20">
                          {" "}
                          <a
                            href="#"
                            className="btn btn-white"
                            data-dismiss="modal"
                          >
                            Close
                          </a>
                          <button type="submit" className="btn btn-danger">
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <div className="main_content">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <TableContainer
                          component={Paper}
                          style={{ overflowX: "auto" }}
                          ref={targetRef}
                        >
                          <Table
                            stickyHeader
                            aria-label="sticky table"
                            className="table-no-card"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell>Sr.No.</TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByAPP === "name"}
                                    direction={
                                      orderByAPP === "name"
                                        ? orderDirectionAPP
                                        : "asc"
                                    }
                                    onClick={() => handleSortAPP("name")}
                                  >
                                    Name
                                  </TableSortLabel>
                                </TableCell>
                                {/* <TableCell>Patient email</TableCell> */}
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByAPP === "email"}
                                    direction={
                                      orderByAPP === "email"
                                        ? orderDirectionAPP
                                        : "asc"
                                    }
                                    onClick={() => handleSortAPP("email")}
                                  >
                                    Email
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByAPP === "city"}
                                    direction={
                                      orderByAPP === "city"
                                        ? orderDirectionAPP
                                        : "asc"
                                    }
                                    onClick={() => handleSortAPP("city")}
                                  >
                                    City
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByAPP === "health_issue"}
                                    direction={
                                      orderByAPP === "health_issue"
                                        ? orderDirectionAPP
                                        : "asc"
                                    }
                                    onClick={() =>
                                      handleSortAPP("health_issue")
                                    }
                                  >
                                    Disease Name
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByAPP === "apt_on"}
                                    direction={
                                      orderByAPP === "apt_on"
                                        ? orderDirectionAPP
                                        : "asc"
                                    }
                                    onClick={() => handleSortAPP("apt_on")}
                                  >
                                    Appointment Date & Time
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByAPP === "paid_amount"}
                                    direction={
                                      orderByAPP === "paid_amount"
                                        ? orderDirectionAPP
                                        : "asc"
                                    }
                                    onClick={() => handleSortAPP("paid_amount")}
                                  >
                                    Paid Amount
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByAPP === "status"}
                                    direction={
                                      orderByAPP === "status"
                                        ? orderDirectionAPP
                                        : "asc"
                                    }
                                    onClick={() => handleSortAPP("status")}
                                  >
                                    Status
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {dataApp.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={9} align="center">
                                    No data found
                                  </TableCell>
                                </TableRow>
                              ) : (
                                dataApp
                                  .slice(
                                    pageAPP * rowsPerPageAPP,
                                    pageAPP * rowsPerPageAPP + rowsPerPageAPP,
                                  )
                                  .map((info, i) => (
                                    <TableRow
                                      role="checkbox"
                                      tabIndex={-1}
                                      key={info.id || info.code || i}
                                    >
                                      <TableCell>
                                        {pdfRowLimit
                                          ? i + 1
                                          : pageAPP * rowsPerPageAPP + i + 1}
                                      </TableCell>
                                      <TableCell title={info?.name}>
                                        {info?.name?.slice(0, 12)}
                                        {info?.name?.length > 12 ? "..." : ""}
                                      </TableCell>
                                      {/* <TableCell>{info.name}</TableCell> */}
                                      <TableCell>{info.email}</TableCell>
                                      <TableCell>{info.city}</TableCell>
                                      <TableCell>{info.health_issue}</TableCell>
                                      <TableCell>
                                        {info?.apt_on ? info?.apt_on : "-"}
                                      </TableCell>
                                      <TableCell>
                                        {formatPaidAmount(info.paid_amount)}
                                      </TableCell>
                                        <TableCell>
                                          <FormControl
                                            size="small"
                                            sx={{ minWidth: 120 }}
                                            className="cont-main"
                                          >
                                            <Select
                                              className="status-direct"
                                              value={getAppAppointmentStatusCode(
                                                info.status ||
                                                  info.appointement_status,
                                              )}
                                              onChange={(e) =>
                                                handleAppStatusChange(
                                                  e,
                                                  info.id || info._id,
                                                  info,
                                                )
                                              }
                                              displayEmpty
                                              inputProps={{
                                                "aria-label": "Without label",
                                              }}
                                            >
                                              <MenuItem value="1">
                                                Confirmed
                                              </MenuItem>
                                              <MenuItem value="2">
                                                Completed
                                              </MenuItem>
                                              <MenuItem value="3">
                                                Cancelled
                                              </MenuItem>
                                              <MenuItem value="4">
                                                Follow-Up
                                              </MenuItem>
                                              <MenuItem value="5">
                                                Rescheduled
                                              </MenuItem>
                                            </Select>
                                          </FormControl>
                                        </TableCell>
                                      <TableCell>
                                        <div className="action-icon">
                                          <VisibilityIcon
                                            className="eye-icon"
                                            onClick={() => handleView(info)}
                                            style={{ cursor: "pointer" }}
                                          />
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))
                              )}
                            </TableBody>
                          </Table>
                          {!pdfRowLimit && (
                            <Stack spacing={2} alignItems="end" marginTop={2}>
                              <Pagination
                                count={Math.ceil(
                                  dataApp.length / rowsPerPageAPP,
                                )}
                                page={pageAPP + 1}
                                onChange={(event, value) =>
                                  setPageAPP(value - 1)
                                }
                                shape="rounded"
                                className="page-item"
                              />
                            </Stack>
                          )}
                        </TableContainer>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel value={tabValue} index={2}>
                <div className="main_content">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <TableContainer
                          component={Paper}
                          style={{ overflowX: "auto" }}
                        >
                          <Table stickyHeader className="table-no-card">
                            <TableHead>
                              <TableRow>
                                <TableCell>Sr.No.</TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByENQ === "patientName"}
                                    direction={orderDirectionENQ}
                                    onClick={() => handleSortENQ("patientName")}
                                  >
                                    Patient Name
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByENQ === "health_issue"}
                                    direction={orderDirectionENQ}
                                    onClick={() =>
                                      handleSortENQ("health_issue")
                                    }
                                  >
                                    Health Issue
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByENQ === "treatment_name"}
                                    direction={orderDirectionENQ}
                                    onClick={() =>
                                      handleSortENQ("treatment_name")
                                    }
                                  >
                                    Treatment Name
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                  <TableSortLabel
                                    active={orderByENQ === "appointment_Date"}
                                    direction={orderDirectionENQ}
                                    onClick={() =>
                                      handleSortENQ("appointment_Date")
                                    }
                                  >
                                    Appointment Date & Time
                                  </TableSortLabel>
                                </TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {enquiryAppointments.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={8} align="center">
                                    No data found
                                  </TableCell>
                                </TableRow>
                              ) : (
                                enquiryAppointments
                                  .slice(
                                    pageENQ * rowsPerPageENQ,
                                    pageENQ * rowsPerPageENQ + rowsPerPageENQ,
                                  )
                                  .map((item, i) => (
                                    <TableRow key={i}>
                                      <TableCell>
                                        {pageENQ * rowsPerPageENQ + i + 1}
                                      </TableCell>
                                      <TableCell title={item?.patientName}>
                                        {item?.patientName?.slice(0, 20)}
                                        {item?.patientName?.length > 20
                                          ? "..."
                                          : ""}
                                      </TableCell>
                                      <TableCell>
                                        {item?.health_issue}
                                      </TableCell>
                                      <TableCell title={item?.treatment_name}>
                                        {item?.treatment_name?.slice(0, 20)}
                                        {item?.treatment_name?.length > 20
                                          ? "..."
                                          : ""}
                                      </TableCell>
                                      <TableCell>
                                        {formatDisplayDateTime(
                                          item?.appointment_Date,
                                          item?.appointment_Time,
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        <FormControl
                                          size="small"
                                          sx={{ minWidth: 120 }}
                                          className="cont-main"
                                        >
                                          <Select
                                            className="status-direct"
                                            value={item.status}
                                            onChange={(e) =>
                                              handleEnqStatusChange(
                                                e,
                                                item._id,
                                                item,
                                              )
                                            }
                                          >
                                            <MenuItem value="Pending">
                                              Pending
                                            </MenuItem>
                                            <MenuItem value="Schedule">
                                              Schedule
                                            </MenuItem>
                                            <MenuItem value="Follow-Up">
                                              Follow-Up
                                            </MenuItem>
                                            <MenuItem value="Complete">
                                              Complete
                                            </MenuItem>
                                            <MenuItem value="Cancelled">
                                              Cancelled
                                            </MenuItem>
                                            <MenuItem value="Reschedule">
                                              Reschedule
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </TableCell>
                                      <TableCell>
                                        <div className="action-icon">
                                          <VisibilityIcon
                                            className="eye-icon"
                                            onClick={() => handleViewEnq(item)}
                                          />
                                          {allowEdit && (
                                          <i
                                            className="fa-solid fa-pen-to-square"
                                            onClick={() => handleEdit(item)}
                                          ></i>
                                          )}
                                          {allowDelete && (
                                            <i
                                              className="fa-solid fa-trash"
                                              onClick={() => handleDelete(item)}
                                            ></i>
                                          )}
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))
                              )}
                            </TableBody>
                          </Table>
                          <Stack spacing={2} alignItems="end" marginTop={2}>
                            <Pagination
                              count={Math.ceil(
                                enquiryAppointments.length / rowsPerPageENQ,
                              )}
                              page={pageENQ + 1}
                              onChange={(e, val) => setPageENQ(val - 1)}
                              shape="rounded"
                              className="page-item"
                            />
                          </Stack>
                        </TableContainer>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={openCreate}
        onClose={handleCloseCreate}
        fullWidth={fullWidth}
        maxWidth="sm"
      >
        <div className="main-card-header">
          <div className="note-hd">
            <h6>Create Appointment</h6>
          </div>
          <div className="cross-icon" onClick={handleCloseCreate}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <DialogContent className="main-box view-table-detail">
          <Box className="contact-form">
            <div className="field-set mb-2">
              <label>
                Patient<span className="text-danger">*</span>
              </label>
              <Autocomplete
                options={appointmentPatientOptions}
                value={createData.patient}
                loading={loadingAppointmentPatients}
                getOptionLabel={getPatientOptionLabel}
                isOptionEqualToValue={(option, value) =>
                  option?.patientId === value?.patientId
                }
                filterOptions={(options, { inputValue }) => {
                  const q = inputValue.trim().toLowerCase();
                  if (!q) return options;
                  return options.filter((p) => {
                    const name = String(p.patient_name || "").toLowerCase();
                    const id = String(
                      p.patientId || p.patientNumber || "",
                    ).toLowerCase();
                    return name.includes(q) || id.includes(q);
                  });
                }}
                onChange={(_, newValue) => {
                  setCreateData((prev) => ({
                    ...prev,
                    patient: newValue,
                    treatment_id: "",
                  }));
                  fetchPatientTreatments(newValue?.patientId);
                }}
                ListboxProps={{ style: { maxHeight: 320 } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder={
                      loadingAppointmentPatients
                        ? "Loading patients..."
                        : "Search Patient"
                    }
                  />
                )}
              />
            </div>

            <div className="field-set mb-2">
              <FormControl fullWidth size="small">
                <label>
                  Treatment
                </label>
                <Select
                  value={createData.treatment_id || ""}
                  displayEmpty
                  onChange={(e) =>
                    setCreateData((prev) => ({
                      ...prev,
                      treatment_id: e.target.value,
                    }))
                  }
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 250 } },
                  }}
                >
                  <MenuItem value="">
                    Select Treatment (Optional)
                  </MenuItem>
                  {patientTreatments.map((item) => (
                    <MenuItem
                      key={item.treatment_id}
                      value={item.treatment_id}
                    >
                      {item.treatment_name ||
                        item.disease_name ||
                        item.treatment_id}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {!hospitalUser && (
              <div className="field-set mb-2">
                <FormControl fullWidth size="small">
                  <label>
                    Select Hospital<span className="text-danger">*</span>
                  </label>
                  <Select
                    value={createData.hospital_id || ""}
                    displayEmpty
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedHospital = hospitalList.find(
                        (item) =>
                          String(item.id) === String(selectedId) ||
                          String(item.hospital_id) === String(selectedId),
                      );
                      setCreateData((prev) => ({
                        ...prev,
                        hospital_id: selectedId,
                        hospital_Name:
                          selectedHospital?.name ||
                          selectedHospital?.hospital_Name ||
                          "",
                        hospital_email:
                          selectedHospital?.email ||
                          selectedHospital?.hospital_email ||
                          "",
                      }));
                    }}
                    MenuProps={{
                      PaperProps: { style: { maxHeight: 250 } },
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select Hospital
                    </MenuItem>
                    {hospitalList?.map((item) => (
                      <MenuItem
                        key={item.id || item.hospital_id}
                        value={item.id ?? item.hospital_id}
                      >
                        {item.name || item.hospital_Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            )}

            <div className="field-set mb-2">
              <h6>Appointment will be:</h6>
              <div className="d-flex gap-3">
                <div className="radio-on">
                  <label>
                    <input
                      type="radio"
                      name="create_mode"
                      value="online"
                      checked={createData.mode === "online"}
                      onChange={(e) =>
                        setCreateData((prev) => ({
                          ...prev,
                          mode: e.target.value,
                        }))
                      }
                    />{" "}
                    Online
                  </label>
                </div>
                <div className="radio-on">
                  <label>
                    <input
                      type="radio"
                      name="create_mode"
                      value="offline"
                      checked={createData.mode === "offline"}
                      onChange={(e) =>
                        setCreateData((prev) => ({
                          ...prev,
                          mode: e.target.value,
                        }))
                      }
                    />{" "}
                    Offline
                  </label>
                </div>
              </div>
            </div>

            <div className="field-set mb-2">
              <label>
                Appointment Date<span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                min={new Date().toISOString().split("T")[0]}
                value={createData.appointment_Date}
                onChange={(e) =>
                  setCreateData((prev) => ({
                    ...prev,
                    appointment_Date: e.target.value,
                  }))
                }
              />
            </div>

            <div className="field-set mb-2">
              <label>
                Appointment Time (Range)<span className="text-danger">*</span>
              </label>
              <div className="row g-2">
                <div className="col-6">
                  <label style={{ fontSize: "12px", color: "#555", marginBottom: "4px", display: "block" }}>
                    From Time<span className="text-danger">*</span>
                  </label>
                  <input
                    type="time"
                    className="form-control"
                    value={createData.appointment_Time_From || ""}
                    onChange={(e) =>
                      setCreateData((prev) => ({
                        ...prev,
                        appointment_Time_From: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="col-6">
                  <label style={{ fontSize: "12px", color: "#555", marginBottom: "4px", display: "block" }}>
                    To Time<span className="text-danger">*</span>
                  </label>
                  <input
                    type="time"
                    className="form-control"
                    value={createData.appointment_Time_To || ""}
                    onChange={(e) =>
                      setCreateData((prev) => ({
                        ...prev,
                        appointment_Time_To: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>
              {createData.appointment_Time_From && createData.appointment_Time_To && (
                <div className="mt-1" style={{ fontSize: "12px", color: "#28a745" }}>
                  <i className="fa-solid fa-clock me-1"></i>
                  Range: <strong>{formatTime12Hour(createData.appointment_Time_From)} to {formatTime12Hour(createData.appointment_Time_To)}</strong>
                </div>
              )}
            </div>

            <div className="field-set mb-2">
              <label>
                Notes<span className="text-danger">*</span>
              </label>
              <textarea
                rows="4"
                className="form-control"
                placeholder="Note"
                value={createData.note}
                onChange={(e) =>
                  setCreateData((prev) => ({
                    ...prev,
                    note: e.target.value,
                  }))
                }
              />
            </div>

            <DialogActions className="submit-main">
              <Button onClick={handleCloseCreate}>Cancel</Button>
              <Button
                variant="contained"
                onClick={handleCreateSubmit}
                disabled={createSubmitting}
              >
                {createSubmitting ? "Submitting..." : "Create Appointment"}
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openReschedule}
        onClose={() => setOpenReschedule(false)}
        fullWidth={fullWidth}
        maxWidth="sm"
        className="reschedule-dialog"
        PaperProps={{ sx: { borderRadius: "8px", overflow: "hidden" } }}
      >
        <div className="main-card-header">
          <div className="note-hd">
            <h6>Reschedule Appointment</h6>
          </div>
          <div
            className="cross-icon reschedule-close"
            onClick={() => setOpenReschedule(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <DialogContent className="reschedule-body">
          <div className="reschedule-info">
            <div>
              <div className="reschedule-info-label">Patient Name</div>
              <div className="reschedule-info-value">
                {rescheduleData.patientName}
              </div>
            </div>
            <div>
              <div className="reschedule-info-label">Current Appointment</div>
              <div className="reschedule-info-value">
                {rescheduleData.currentAppointment}
              </div>
            </div>
          </div>
          <div className="reschedule-fields-row">
            <div className="field-set">
              <label>
                Appointment Date<span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                value={rescheduleData.appointment_Date}
                onChange={(e) =>
                  setRescheduleData((prev) => ({
                    ...prev,
                    appointment_Date: e.target.value,
                  }))
                }
              />
            </div>
            <div className="field-set">
              <label>
                Appointment Time<span className="text-danger">*</span>
              </label>
              <input
                type="time"
                className="form-control"
                value={rescheduleData.appointment_Time}
                onChange={(e) =>
                  setRescheduleData((prev) => ({
                    ...prev,
                    appointment_Time: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </DialogContent>
        <div className="reschedule-actions">
          <Button
            onClick={() => setOpenReschedule(false)}
            className="reschedule-cancel-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={handleRescheduleSubmit}
            className="reschedule-submit-btn"
            variant="contained"
            disabled={rescheduleSubmitting}
          >
            {rescheduleSubmitting ? "Submitting..." : "Reschedule"}
          </Button>
        </div>
      </Dialog>
      {/* Confirm Appointment Dialog */}
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        fullWidth={fullWidth}
        maxWidth="sm"
        className="reschedule-dialog"
        PaperProps={{ sx: { borderRadius: "8px", overflow: "hidden" } }}
      >
        <div className="main-card-header">
          <div className="note-hd">
            <h6>Confirm Appointment</h6>
          </div>
          <div
            className="cross-icon reschedule-close"
            onClick={() => setOpenConfirm(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <DialogContent className="reschedule-body">
          <div className="reschedule-info">
            <div>
              <div className="reschedule-info-label">Patient Name</div>
              <div className="reschedule-info-value">
                {confirmData.patientName}
              </div>
            </div>
            <div>
              <div className="reschedule-info-label">Requested Time</div>
              <div className="reschedule-info-value">
                {confirmData.currentAppointment}
              </div>
            </div>
          </div>
          <div className="reschedule-fields-row">
            <div className="field-set">
              <label>
                Confirmed Date<span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                value={confirmData.appointment_Date}
                onChange={(e) =>
                  setConfirmData((prev) => ({
                    ...prev,
                    appointment_Date: e.target.value,
                  }))
                }
              />
            </div>
            <div className="field-set">
              <label>
                Exact Time<span className="text-danger">*</span>
              </label>
              <input
                type="time"
                className="form-control"
                value={confirmData.appointment_Time}
                onChange={(e) =>
                  setConfirmData((prev) => ({
                    ...prev,
                    appointment_Time: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </DialogContent>
        <div className="reschedule-actions">
          <Button
            onClick={() => setOpenConfirm(false)}
            className="reschedule-cancel-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmSubmit}
            className="reschedule-submit-btn"
            variant="contained"
            disabled={confirmSubmitting}
            style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
          >
            {confirmSubmitting ? "Confirming..." : "Confirm & Save Exact Time"}
          </Button>
        </div>
      </Dialog>
      {/* Cancel Appointment Dialog */}
      <Dialog
        open={openCancel}
        onClose={() => setOpenCancel(false)}
        fullWidth={fullWidth}
        maxWidth="sm"
        className="cancel-appointment-dialog"
        PaperProps={{ sx: { borderRadius: "8px", overflow: "hidden" } }}
      >
        <div className="main-card-header">
          <div className="note-hd">
            <h6>Cancel Appointment</h6>
          </div>
          <div
            className="cross-icon cancel-dialog-close"
            onClick={() => setOpenCancel(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <DialogContent className="cancel-dialog-body">
          <div className="cancel-dialog-info">
            <div>
              <div className="cancel-dialog-info-label">Patient Name</div>
              <div className="cancel-dialog-info-value">
                {cancelData.patientName}
              </div>
            </div>
            <div>
              <div className="cancel-dialog-info-label">Current Appointment</div>
              <div className="cancel-dialog-info-value">
                {cancelData.currentAppointment}
              </div>
            </div>
          </div>
          <div className="cancel-dialog-fields">
            <div className="field-set mb-3">
              <label>
                Cancellation Reason<span className="text-danger">*</span>
              </label>
              <select
                className="form-control"
                value={cancelData.cancel_reason_id}
                onChange={(e) =>
                  setCancelData((prev) => ({
                    ...prev,
                    cancel_reason_id: e.target.value,
                  }))
                }
              >
                <option value="">Select Cancellation Reason</option>
                {cancelReasons.map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.reason}
                  </option>
                ))}
              </select>
            </div>
            <div className="field-set mb-0">
              <label>
                Cancel Note <span className="text-muted" style={{ fontSize: "12px" }}>(optional)</span>
              </label>
              <textarea
                className="form-control"
                rows={3}
                placeholder="Enter cancellation note..."
                value={cancelData.cancel_note}
                onChange={(e) =>
                  setCancelData((prev) => ({
                    ...prev,
                    cancel_note: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </DialogContent>
        <div className="cancel-dialog-actions">
          <Button
            onClick={() => setOpenCancel(false)}
            className="cancel-dialog-cancel-btn"
          >
            Close
          </Button>
          <Button
            onClick={handleCancelSubmit}
            className="cancel-dialog-submit-btn"
            variant="contained"
            disabled={cancelSubmitting}
          >
            {cancelSubmitting ? "Cancelling..." : "Confirm Cancel"}
          </Button>
        </div>
      </Dialog>
      <Dialog
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        fullWidth={fullWidth}
        maxWidth="sm"
      >
        <div className="main-card-header">
          <div className="note-hd">
            <h6>Edit Appointment</h6>
          </div>
          <div className="cross-icon" onClick={() => setOpenEdit(false)}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <DialogContent className="main-box view-table-detail">
          <Box
            className="contact-form"
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "fit-content",
              minHeight: "350px",
            }}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="field-set">
                  <FormControl fullWidth size="small">
                    <label>
                      Select Hospital
                    </label>
                    <Select
                      value={editData.hospital_id || ""}
                      onChange={(e) => {
                        const selectedId = e.target.value;

                        const selectedHospital = hospitalList.find(
                          (item) => item.id === selectedId,
                        );
                        setEditData((prev) => ({
                          ...prev,
                          hospital_id: selectedId,
                          hospitalName: selectedHospital?.name || "",
                        }));
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250,
                          },
                        },
                      }}
                    >
                      {hospitalList?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="col-md-12">
                <div className="field-set">
                  <label>
                    Health Issue
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={editData.health_issue || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        health_issue: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="field-set">
                  <label>
                    Treatment Name
                  </label>
                  <Autocomplete
                    options={Treatment || []}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      Treatment?.find(
                        (item) => item.id == editData.treatment_id,
                      ) || null
                    }
                    onChange={(e, value) => {
                      setEditData((prev) => ({
                        ...prev,
                        treatment_id: value?.id || "",
                        treatment_name: value?.name || "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select Treatment" />
                    )}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        padding: "0px",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="field-set">
                  <label>
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={editData.appointment_Date?.split("T")[0] || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        appointment_Date: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="field-set">
                  <label>
                    Time<span className="text-danger">*</span>
                  </label>
                  <input
                    type="time"
                    className="form-control"
                    value={getTimeInputValue(
                      editData.appointment_Date,
                      editData.appointment_Time,
                    )}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        appointment_Time: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="field-set">
                  <label>
                    Notes<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={editData.discussionNotes || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        discussionNotes: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="field-set">
                  <label>
                    Upload Reports<span className="text-danger">*</span>
                  </label>
                  <span className="text-danger"></span>
                  <input
                    type="file"
                    multiple
                    className="form-control"
                    onChange={(e) => setEditImages(Array.from(e.target.files))}
                  />
                </div>
              </div>
            </div>
          </Box>
          <DialogActions className="submit-main">
            <Button
              onClick={handleUpdate}
              className="add-button"
              variant="contained"
            >
              Edit Appointment
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={openViewEnq}
        onClose={handleCloseViewEnq}
      >
        <div className="main-card-header">
          <div className="top-fixed-hd">
            <div className="note-hd">
              <h6>Enquiry Appointment Details</h6>
            </div>
            <div className="cross-icon" onClick={handleCloseViewEnq}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
        </div>
        <DialogContent className="main-box view-table-detail">
          {selectedEnq && (
            <Box>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <InfoItem
                            label="Patient Name"
                            value={selectedEnq.patientName}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Hospital Name"
                            value={selectedEnq.hospitalName}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Health Issue"
                            value={selectedEnq.health_issue}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Treatment Name"
                            value={selectedEnq.treatment_name}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Appointment Date"
                            value={new Date(
                              selectedEnq.appointment_Date,
                            ).toLocaleDateString("en-GB")}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Appointment Time"
                            value={selectedEnq.appointment_Time}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem label="Status" value={selectedEnq.status} />
                        </div>

                        {/* Notes full width */}
                        <div className="col-md-12">
                          <h6>Notes</h6>
                          <p>{selectedEnq.discussionNotes || "-"}</p>
                        </div>

                        {/* Reports full width */}
                        <div className="col-md-12 mt-2">
                          <h6>Reports</h6>

                          {selectedEnq.reports?.length > 0 ? (
                            selectedEnq.reports.map((file, i) => (
                              <div key={i}>
                                <a
                                  href={`${baseu11}/${file}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  View Report {i + 1}
                                </a>
                              </div>
                            ))
                          ) : (
                            <p>-</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
      >
        <div className="main-card-header">
          <div className="top-fixed-hd">
            <div className="note-hd">
              <h6>Detail's</h6>
            </div>
            <div className="cross-icon" onClick={handleClose}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
        </div>
        <DialogContent className="main-box view-table-detail">
          {selectedRecord && (
            <Box>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <InfoItem label="Name" value={selectedRecord.name} />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Email"
                            value={selectedRecord.email}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Phone Number"
                            value={selectedRecord.phone}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Appointment Type"
                            value={selectedRecord.apt_type}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem label="City" value={selectedRecord.city} />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Country"
                            value={selectedRecord.country}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Doctor"
                            value={selectedRecord.doctor}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Health Issue"
                            value={selectedRecord.health_issue}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Home Visit Address"
                            value={selectedRecord.home_visit_address}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Paid Amount"
                            value={formatPaidAmount(selectedRecord.paid_amount)}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Treatment"
                            value={selectedRecord.treatment}
                          />
                        </div>
                        <div className="col-md-4">
                          <InfoItem
                            label="Status"
                            value={getAppAppointmentStatusLabel(
                              selectedRecord.status ||
                                selectedRecord.appointement_status,
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      <ToastContainer />
    </>
  );
}
